import request from "@/utils/request";

export const url = {
  GetRoomStatus: "/api/ARI/GetRoomStatus",
  Room_SetRepairBegin: "/api/RoomNo/SetRepairBegin", //设维修
  Room_SetRepairEnd: "/api/RoomNo/SetRepairEnd", //解除维修
  Room_Clean: "/api/RoomNo/SetClean", //设置房间清洁，置脏 设脏为true ,清洁为false
  Room_GetRoomPrice: "/api/ARI/GetRoomPrice", //获取房价
  Room_GetLog: "/api/RoomNo/GetRoomLogPageList", //获取房间日志
  Room_Available: "/api/ARI/GetAvailableRooms", //获取可用房型
  Room_GetRoomForecast: "/api/GroupPredictRoomStatus/GetCompanyRoomStatus", //获取房态预测数据
  Get_DepositList: "/api/AccountMaintenance/GetDepositList", //获取押金代码列表
  // VerificationMemberPass: "/api/MemberInfo/VerificationPassword" //验证密码
  Order_GetContact: "/api/Order/GetOrderByContactPageList", // 通过姓名查询客人订单历史记录
  SetLockBegin: "/api/RoomNo/SetLockBegin", //开始封房
  SetLockEnd: "/api/RoomNo/SetLockEnd", //结束封房
};
function sendRequest(apiUrl, params, type) {
  return request({
    url: apiUrl,
    method: type,
    data: params,
  });
}

export default class roomApi {
  /**
   * 获取房态信息
   * @description: 获取房态
   * @param {Object} data
   * @return:
   */
  static GetRoomStatus(params, type = "post") {
    return sendRequest(url.GetRoomStatus, params, type);
  }
  /**
   * 设维修
   * @description: 设维修
   * @param {Object} data
   * @return:
   */
  static SetRepairBegin(params, type = "post") {
    return sendRequest(url.Room_SetRepairBegin, params, type);
  }
  /**
   * 解除维修
   * @description: 解除维修
   * @param {Object} data
   * @return:
   */
  static SetRepairEnd(params, type = "post") {
    return sendRequest(url.Room_SetRepairEnd, params, type);
  }
  /**
   * 设置房间清洁，置脏,设脏为true ,清洁为false
   * @description: 设脏为true ,清洁为false
   * @param {Object} data
   * @return:
   */
  static SetRoomClean(params, type = "post") {
    return sendRequest(url.Room_Clean, params, type);
  }
  /**
   * 获取房价
   * @description:  获取房价
   * @param {Object} data 搜索条件
   * @return:
   */
  static GetRoomPrice(params, type = "post") {
    return sendRequest(url.Room_GetRoomPrice, params, type);
  }
  /**
   * 获取房间日志列表
   * @description:  获取房间日志列表
   * @param {Object} data 搜索条件
   * @return:
   */
  static GetRoomLog(params, type = "post") {
    return sendRequest(url.Room_GetLog, params, type);
  }
  /**
   * 获取可用房型
   * @description:  获取可用房型
   * @param {Object} data 搜索条件
   * @return:
   */
  static GetRoomAvailable(params, type = "post") {
    return sendRequest(url.Room_Available, params, type);
  }
  /**
   * 获取房态与预测数据
   * @description:  获取房态与预测数据
   * @param {Object} data 搜索条件
   * @return:
   */
  static GetRoomForecast(params, type = "post") {
    return sendRequest(url.Room_GetRoomForecast, params, type);
  }

  /**
   * 获取付款方式
   * @description:  获取付款方式
   * @param {Object} data 搜索条件
   * @return:
   */
  static GetDepositList(params, type = "post") {
    return sendRequest(url.Get_DepositList, params, type);
  }

  /**
   * 获取联系人
   * @description:  获取联系人
   * @param {Object} data 搜索条件
   * @return:
   */
  static GetContact(params, type = "post") {
    return sendRequest(url.Order_GetContact, params, type);
  }

  static setLockBegin(params, type = "post") {
    return sendRequest(url.SetLockBegin, params, type);
  }
  static setLockEnd(params, type = "post") {
    return sendRequest(url.SetLockEnd, params, type);
  }
}
